/** @hidden */
var _TypeStore = /** @class */function () {
  function _TypeStore() {}
  /** @hidden */
  _TypeStore.GetClass = function (fqdn) {
    if (this.RegisteredTypes && this.RegisteredTypes[fqdn]) {
      return this.RegisteredTypes[fqdn];
    }
    return null;
  };
  /** @hidden */
  _TypeStore.RegisteredTypes = {};
  return _TypeStore;
}();
export { _TypeStore };